import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, Smartphone, X } from "lucide-react";
import "./InstallAppBanner.css";

const STORAGE_KEY = "shahrizada-pwa-banner-dismissed";

function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

const InstallAppBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [hidden, setHidden] = useState(isStandalone());

  useEffect(() => {
    setHidden(isStandalone());
  }, []);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    return () =>
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, []);

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
    setDismissed(true);
  }, []);

  const install = useCallback(async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice.catch(() => {});
    setDeferredPrompt(null);
  }, [deferredPrompt]);

  if (hidden || dismissed) return null;

  return (
    <div className="InstallBanner" role="region" aria-label="Установка приложения">
      <div className="InstallBanner--Card">
        <div className="InstallBanner--Head">
          <div className="InstallBanner--Lead">
            <span className="InstallBanner--Icon" aria-hidden="true">
              <Smartphone size={20} strokeWidth={2} />
            </span>
            <div className="InstallBanner--Copy">
              <span className="InstallBanner--Title">Приложение на телефоне</span>
              <p className="InstallBanner--Text">
                Добавьте кафе на главный экран — открывается быстрее, как отдельное
                приложение.
              </p>
            </div>
          </div>
          <button
            type="button"
            className="InstallBanner--Dismiss"
            onClick={dismiss}
            aria-label="Скрыть"
          >
            <X size={20} strokeWidth={2} />
          </button>
        </div>

        <div className="InstallBanner--Buttons">
          <Link className="InstallBanner--Btn InstallBanner--Btn--guide" to="/install">
            Как добавить на экран (iPhone и Android)
          </Link>
          {deferredPrompt ? (
            <button
              type="button"
              className="InstallBanner--Btn InstallBanner--Btn--install"
              onClick={install}
            >
              <Download size={18} strokeWidth={2} />
              Установить приложение
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default InstallAppBanner;
